import { useQuery } from '@tanstack/react-query'
import { fetchWorld } from '@/services/worlds'

export function useWorld(id: string | undefined) {
  const worldQuery = useQuery({
    queryKey: ['world', id],
    queryFn: () => fetchWorld(id!),
    enabled: !!id,
  })

  return {
    world: worldQuery.data,
    isLoading: worldQuery.isLoading,
    error: worldQuery.error,
  }
}
